import { MainInfo } from '../util/model';

function setToken(token: string | null) {
    if(token === null) {
        removeToken();
        return;
    }
    localStorage.setItem('TOKEN', token);
}

function getToken(): string | null {
    return localStorage.getItem('TOKEN')
}

function removeToken() {
    localStorage.removeItem("TOKEN");
    return null;
}
function mainInfo(): MainInfo {
    const t = getToken()!;
    if (!t) {
        throw new Error("Token not found");
    }
    const base64Str = t.split('.')[1]
    const jsonStr =  atob(base64Str)
    return JSON.parse(jsonStr);
}

export const TokenService = {
    setToken,
    getToken,
    removeToken,
    mainInfo,
}
